<template>
  <div class="login container">
    <div v-if="!redeemCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <div v-else>
      <form @submit.prevent="$nextTick(submit)">

          <div class="d-flex justify-content-between">
          <div class="col-xs-6 pl-3 pt-5">
            <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
          </div>


          <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!card_reference || errors.has('card_reference')" margin="no-margin" :loading="submitted" />
          </div>
          </div>


          <div class="row">
          <h2 class="col-md-12 pt-2">Enter customer's card unique code</h2>
          </div>

          <div class="row d-flex justify-content-center">
          <div class="text-input-holder col-sm-12 pt-4 size-limit">
            <text-input :allowModelSet="true"  v-model="card_reference" placeholder="Enter unique code" name="card_reference" v-validate="'required'"  />
          </div>
          </div>

      </form>

      <div class="row">
        <h4 class="col-md-12 mt-5 mb-3">Scan QR code</h4>
         <div class=" col-md-12 d-flex justify-content-center align-items-center">
           <div :class="`view-finder-wrapper d-flex justify-content-center align-items-center`">
              <div class="loader"></div>
              <qrcode-stream v-if="!destroyed" :camera="camera" :class="`view-finder ${cameraActivated ? '':'d-none'}`" @decode="onDecode" @init="onInit"></qrcode-stream>
              <button :class="`activate-camera-button ${cameraActivated ? 'd-none':''}`" @click="toggleCamera">Activate Camera</button>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
  name: 'Login',
  components: {
     QrcodeStream,
  },
  inject: ['$validator'],
  data : function(){       
      return {
        card_reference: '',
        submitted     : false,
        camera:'auto',
        error:'',
        destroyed: false
      };

  },
  created:function(){
    if(this.card.card_reference)
      this.card_reference = this.card.card_reference;
    
  },
  computed: {
    card()
    {
        return this.$store.getters.getCard;
    },
    cameraActivated() {
        return this.$store.getters.getCameraActivated;
    },
    accountId(){
        return this.$store.getters.getAccountId;
    }
  },
  methods:{
      /*
      * Decode QR code
      */
      onDecode(decodedString) {
          this.card_reference = decodedString;
          
          this.reload()
      },
      async reload () {
        this.destroyed = true

        await this.$nextTick()

        this.destroyed = false
      },
      toggleCamera() {
        this.$store.commit('SET_CAMERA_ACTIVATED',!this.cameraActivated)
      },
       async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },
      /*
      * Login form submit handler
      */
      submit()
      {
    
          this.card_reference = this.card_reference.replace(/[^a-zA-Z0-9\s+\-.]/g, ''); 
        
          this.$validator.validateAll().then((result) => {
            if(result){

              this.submitted = true;

              window.axios({
                url: process.env.VUE_APP_API_GRAPH_URL,
                method: 'post',
                data: {
                  query: `
                    query($account_id:Int!,$limit:Int!,$page:Int!,$card_reference:String!){
                              Cards(account_id:$account_id, card_reference:$card_reference, limit:$limit, page:$page){
                                data{
                                  id,
                                  card_reference,
                                  card_alias_card_reference,
                                  balance,
                                  Currency{symbol, denomination},
                                  product_name,
                                  Account{id}
                                }
                                total,
                                per_page
                              },
                          }
                        `,
                        variables: {
                          account_id: this.accountId,
                          card_reference: this.card_reference,
                          page          : 1,
                          limit         : 1,
                        }
                }
              }).then((result) => {

                if(result.data.data && result.data.data.Cards.data.length){
                  this.$store.commit('SET_CARD', result.data.data.Cards.data[0]);
                  this.$router.push({ name: 'redeem-amount'});
                }else{
                  this.errors.add({field:'card_reference',msg:'Card not found'});
                }
              }).catch( () => {
                  this.$bus.$emit('error_message', 'Something went wrong, please try again!');
              }).then(() => {
                  this.submitted = false;
              });
              
            }
          });


      },

     


  }
}
</script>

<style scoped>
.loader {
  position: absolute;
}
</style>
